export default __webpack_public_path__ + "static/media/icon-verify-email.a55b6652.svg";